var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDartsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-887.000000, -472.000000)",
    fill: "#00000061"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(883.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3913043,26.6955043 C6.16365948,26.6955043 0.304495652,20.8363405 0.304495652,13.6086957 C0.304495652,6.38105079 6.16365948,0.521886957 13.3913043,0.521886957 C20.6189492,0.521886957 26.478113,6.38105079 26.478113,13.6086957 C26.478113,20.8363405 20.6189492,26.6955043 13.3913043,26.6955043 Z M13.3913043,25.0871043 C19.7306544,25.0871043 24.869713,19.9480457 24.869713,13.6086957 C24.869713,7.26934558 19.7306544,2.13028696 13.3913043,2.13028696 C7.05195427,2.13028696 1.91289565,7.26934558 1.91289565,13.6086957 C1.91289565,19.9480457 7.05195427,25.0871043 13.3913043,25.0871043 Z",
    id: "Oval",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3913043,20.9346348 C9.34529989,20.9346348 6.06536522,17.6547001 6.06536522,13.6086957 C6.06536522,9.56269119 9.34529989,6.28275652 13.3913043,6.28275652 C17.4373088,6.28275652 20.7172435,9.56269119 20.7172435,13.6086957 C20.7172435,17.6547001 17.4373088,20.9346348 13.3913043,20.9346348 Z M13.3913043,19.3262348 C16.549014,19.3262348 19.1088435,16.7664053 19.1088435,13.6086957 C19.1088435,10.450986 16.549014,7.89115652 13.3913043,7.89115652 C10.2335947,7.89115652 7.67376522,10.450986 7.67376522,13.6086957 C7.67376522,16.7664053 10.2335947,19.3262348 13.3913043,19.3262348 Z",
    id: "Oval",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3913043,15.2824609 C12.4669093,15.2824609 11.7175391,14.5330907 11.7175391,13.6086957 C11.7175391,12.6843006 12.4669093,11.9349304 13.3913043,11.9349304 C14.3156994,11.9349304 15.0650696,12.6843006 15.0650696,13.6086957 C15.0650696,14.5330907 14.3156994,15.2824609 13.3913043,15.2824609 Z",
    id: "Oval",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDartsGrey);
export default __webpack_public_path__ + "static/media/dartsGrey.2b51ef951ba53150d2a190b8dfe452cf.svg";
export { ForwardRef as ReactComponent };